import React from "react"
import orgChartData from "../data/org-chart.json"

export default function OrgChart() {
  const Section = ({ children, section }) => {
    return (
      <section className={`org-chart__section org-chart--${section.slug}`}>
        {section.id !== "" && (
          <header>
            <h3 className="title--m md:title--l">{section.id}</h3>
          </header>
        )}
        <div className="org-chart__section__grid">{children}</div>
      </section>
    )
  }

  const renderOrgChart = () => {
    const renderPeople = people => {
      let items = people.map((person, index) => {
        return (
          <div
            key={index}
            className={`org-chart__section__department__person ${
              person.sub ? "org-chart__section__department__person--sub" : ""
            }`}
          >
            <h6 className="org-chart__section__department__person__name">
              {person.name}
            </h6>
            <p className="org-chart__section__department__person__title">
              {person.title}
            </p>
            {person.notes && (
              <span className="org-chart__section__department__person__notes">
                {person.notes}
              </span>
            )}
          </div>
        )
      })
      return items
    }

    const renderDepartments = children => {
      let items = children.map((item, index) => {
        return (
          <div key={index} className="org-chart__section__department">
            <h4 className="org-chart__section__department__title">{item.id}</h4>
            {renderPeople(item.people)}
          </div>
        )
      })
      return items
    }

    const sections = orgChartData.map((section, index) => {
      return (
        <Section key={index} section={section}>
          {renderDepartments(section.departments)}
        </Section>
      )
    })
    return sections
  }

  return renderOrgChart()
}
